module.exports = __webpack_public_path__ + "static/media/8.36580e4c.svg";